import axios from 'axios';
import { useCallback, useReducer } from 'react';
import { Page } from '../../types/Types';
import ActionTypes from '../Action.types';
import FacebookPageReducer from './FacebookPage.reducer';

const INITIAL_STATE = {
  pages: [],
  isLoading: false,
  errMessage: '',
};

const FacebookPageHooks = () => {
  const [state, dispatch] = useReducer(FacebookPageReducer, INITIAL_STATE);

  const fetchPages = useCallback(async (type: string, status: string) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      const res: any = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/pages?type=${type}&status=${status}`
      );

      dispatch({ type: ActionTypes.find, payload: res.data });
    } catch (err: any) {
      if (err.response) {
        console.log(err.response.data.message);
      } else {
        console.log(err.message);
      }
    }
  }, []);

  const fetchPageByDate = useCallback(async (startDate: Date, endDate: Date) => {
    dispatch({ type: ActionTypes.start, payload: '' });

    try {
      const setHoursStartDate = new Date(new Date(startDate).setHours(0, 0, 0));
      const setHoursEndDate = new Date(new Date(endDate).setHours(23, 59, 59));

      const res: any = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/pages/getByDate/startDate=${setHoursStartDate}&endDate=${setHoursEndDate}`
      );


      dispatch({ type: ActionTypes.find, payload: res.data });
    } catch (err: any) {
      if (err.response) {
        console.log(err.response.data.message);
      } else {
        console.log(err.message);
      }
    }
  }, []);

  // ------------------------------------------------------------------ //
  // ----------------------------- UPLOAD ----------------------------- //
  // ------------------------------------------------------------------ //

  const uploadPages = (getData: any) => {
    try {
      dispatch({ type: ActionTypes.upload, payload: getData });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  // ----------------------------------------------------------------------- //
  // ----------------------------- UPDATE----- ----------------------------- //
  // ----------------------------------------------------------------------- //
  const editPage = async (page: Page) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      dispatch({ type: ActionTypes.update, payload: page });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  // ----------------------------------------------------------------------- //
  // ----------------------------- UPDATE MANY ----------------------------- //
  // ----------------------------------------------------------------------- //

  const editManyPages = (itemsId: [], editData: Page) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      dispatch({
        type: ActionTypes.update_many,
        payload: { itemsId, editData },
      });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  const editStockAgent = (itemsId: string[], editData: Page) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      dispatch({
        type: 'EDIT_STOCK_AGENT',
        payload: { itemsId, editData },
      });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  // ------------------------------------------------------------------ //
  // ----------------------------- DELETE ----------------------------- //
  // ------------------------------------------------------------------ //

  const deletePage = (itemId: string) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      dispatch({ type: ActionTypes.delete, payload: itemId });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  // ----------------------------------------------------------------------- //
  // ----------------------------- DELETE MANY ----------------------------- //
  // ---------------------------------------------------------------------- //
  const deleteManyPages = (itemsId: any) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      dispatch({ type: ActionTypes.delete_many, payload: itemsId });
    } catch (err: any) {
      console.log(err.message);
    }
  };

  return {
    state,
    fetchPages,
    uploadPages,
    editPage,
    deletePage,
    deleteManyPages,
    editManyPages,
    editStockAgent,
    fetchPageByDate
  };
};

export default FacebookPageHooks;
